import React from "react";
import { X } from "lucide-react";
import { legalContent } from "../legalContent";


export default function LegalModal({ type, isOpen, onClose }) {
  if (!isOpen) return null;

  

  const active = legalContent[type];


  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>{active.title}</h2>
          <button onClick={onClose} style={styles.closeBtn}>
            <X size={20} />
          </button>
        </div>
        <div style={styles.body}>
          {active.body.map((line, i) => (
            <p key={i} style={styles.text}>{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { 
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh", 
    background: "rgba(0,0,0,0.85)", 
    backdropFilter: "blur(10px)", 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center", 
    zIndex: 2000 
  },
  modal: { 
    width: "90%", 
    maxWidth: "520px", 
    background: "#0f172a", 
    borderRadius: "24px", 
    border: "1px solid #1e293b", 
    padding: "32px", 
    position: "relative",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
  },
  header: { 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center", 
    marginBottom: "20px", 
    borderBottom: "1px solid #1e293b", 
    paddingBottom: "16px" 
  },
  title: { 
    color: "#fff", 
    margin: 0, 
    fontSize: "20px", 
    fontWeight: 700 
  },
  closeBtn: { 
    background: "none", 
    border: "none", 
    color: "#64748b", 
    cursor: "pointer",
    padding: "4px"
  },
  body: { 
    maxHeight: "65vh", 
    overflowY: "auto", 
    paddingRight: "12px",
    textAlign: "left",
    scrollbarWidth: "thin",
    scrollbarColor: "#1e293b transparent"
  },
  text: { 
    color: "#94a3b8", 
    fontSize: "13.5px", 
    lineHeight: "1.8", 
    marginBottom: "16px" 
  }
};